import { Navigate, useParams } from 'react-router';
export function PublicRedirect({
  kind,
}: {
  kind: 'profile' | 'post' | 'shop' | 'specialists';
}) {
  const { id } = useParams();
  return (
    <Navigate
      replace
      to={
        Number(id) > 0
          ? `/app/${kind === 'specialists' ? 'specialists/listings' : kind}/${id}`
          : '/app/feed'
      }
    />
  );
}
